import { render, staticRenderFns } from "./ChallengeRules.vue?vue&type=template&id=2ec1571c"
import script from "./ChallengeRules.vue?vue&type=script&lang=js"
export * from "./ChallengeRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports